import { render, staticRenderFns } from "./Level3View.vue?vue&type=template&id=47b1d9be&"
import script from "./Level3View.vue?vue&type=script&lang=js&"
export * from "./Level3View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports